
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationL as ObiLocationLElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-l.js';
 
 
 

 
 export const ObiLocationL = createComponent({
   react: React,
   tagName: 'obi-location-l',
   elementClass: ObiLocationLElement,
   events: {
     
   }
  });
 
 